import { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70 shadow-sm' : 'bg-background-50'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <RouterLink to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-bold text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>韩漫网</span>
            <span className="hidden sm:block text-xs text-foreground-500">全网最全无删减韩国漫画</span>
          </RouterLink>

          <div className="hidden md:flex items-center gap-8">
            <RouterLink to="/" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}>
              首页
            </RouterLink>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                漫画分类
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 border border-background-200/70 rounded-lg shadow-lg py-2 z-50">
                  {categories.map(cat => (
                    <RouterLink
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${cat.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                      {cat.name}
                    </RouterLink>
                  ))}
                </div>
              )}
            </div>

            <RouterLink to="/category/romance" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname.includes('/category/') ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}>
              最新更新
            </RouterLink>

            <RouterLink to="/about" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-primary-500'}`}>
              关于我们
            </RouterLink>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="text-sm px-4 py-2 rounded-md border border-background-200/70 text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-search-line mr-1"></i>搜索
            </button>
            <button className="text-sm px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              开始阅读
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 flex flex-col gap-3">
            <RouterLink to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">首页</RouterLink>
            <div className="text-sm font-medium text-foreground-700 py-2">漫画分类</div>
            <div className="grid grid-cols-2 gap-2 pl-2">
              {categories.map(cat => (
                <RouterLink
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 py-1.5 whitespace-nowrap"
                >
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
                  {cat.name}
                </RouterLink>
              ))}
            </div>
            <RouterLink to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">关于我们</RouterLink>
            <div className="flex gap-2 pt-2">
              <button className="flex-1 text-sm py-2 rounded-md border border-background-200/70 text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">搜索</button>
              <button className="flex-1 text-sm py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">开始阅读</button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}